export function checkWord(str, substr) {
    return str.indexOf(substr) !== -1
} // принимает: строку, подстроку возвращает: true - если подстрока есть
